import React, {Component} from 'react';
import {Translation} from 'react-i18next';

import PartnershipForm from '../containers/PartnershipFormContainer';
import DocumentHead from '../../../elements/components/DocumentHead';
import Logger from '../../../../../lib/Logger';

class PartnershipEditScreen extends Component {

  scrollToTop = () => {
    Logger.log('debug', `PartnershipEditScreen.scrollToTop()`);
    if (typeof window !== 'undefined') {
      setTimeout(() => window.scrollTo(0, 0), 100);
    }
  }

  render() {
    return (
      <Translation>{(t) => 
        <div>
          <DocumentHead title={t('partnership_route_edit')} />
          <PartnershipForm id={this.props.match.params.id} />
        </div>
      }</Translation>
    )
  }

  /* LIFECYCLE EVENTS */

  componentDidMount() {
    this.scrollToTop();
  }
}

export default PartnershipEditScreen;

Logger.log('silly', `PartnershipEditScreen loaded.`);
